import React from 'react';
import { Control, FieldArrayWithId } from 'react-hook-form';
import { Add as AddIcon } from '@mui/icons-material';
import { Box, Button, Stack, Typography } from '@mui/material';
import { Listing } from 'components/shared/TableListing/table/Listing';
import { DealBuilderFormValues, TradeInListingItem } from '../../../types';
import { getTradeInListingColumns } from '../../../lib';

interface Props {
  control: Control<DealBuilderFormValues>;
  fields: FieldArrayWithId<DealBuilderFormValues, 'pricing.tradeIn'>[];
  onFieldBlur: (rowIndex: number) => void;
  onRemoveRow: (rowIndex: number) => void;
  onAddRow: () => void;
}

export const TradeInListing = ({ control, fields, onFieldBlur, onRemoveRow, onAddRow }: Props) => {
  const columns = getTradeInListingColumns({ control, onFieldBlur, onRemoveRow });

  return (
    <Stack gap="1rem">
      <Listing<TradeInListingItem>
        tableData={fields}
        columns={columns}
        actionPanelTop={() => (
          <Stack direction="row">
            <Typography variant="h6" component="span">
              Trade-In
            </Typography>
            {/*             <Button variant="text" sx={{ ml: 'auto' }} onClick={onRemoveAll} size="small">
              Remove Trade-In
            </Button> */}
          </Stack>
        )}
        actionPanelBottom={() => (
          <Box>
            <Button variant="outlined" size="small" startIcon={<AddIcon fontSize="small" />} onClick={onAddRow}>
              Add More
            </Button>
          </Box>
        )}
      />
    </Stack>
  );
};
